import { Frame } from './event';
import type { TimelineInterval } from './streaming';

export interface TimelineSeekPreview {
    timestamp: number;
    window: TimelineInterval;
}

export interface BoundingBoxData {
    frames: Frame[];
    id: string;
    snapshotFrameId: number;
    focuses: number[][];
    // Scene event boxes come from VLM grounding and are only used to crop the
    // thumbnail, so they are never drawn over the video.
    drawBoxes: boolean;
}

export interface PictureRect {
    width: number;
    height: number;
    offsetX: number;
    offsetY: number;
    scaleX: number;
    scaleY: number;
}

export interface VideoSize {
    height: number;
    width: number;
}

export interface LoopWindow {
    endTime: number;
    startTime: number;
    playbackStart: number;
    domain: TimeDomain;
}

export interface EventPlaybackRange {
    domain: TimeDomain;
    origin: RangeOrigin;
    start: number;
    end: number;
    playbackStart: number;
}

export interface HighlightRegion {
    endTime: number;
    id: string;
    startTime: number;
    type: HighlightType;
    domain: TimeDomain;
}

export enum HighlightType {
    EVENT = 'event',
    FOCUS = 'focus',
}

export enum PlaybackDirection {
    Rewind = 'rewind',
    Forward = 'forward',
}

export enum TimeDomain {
    ABSOLUTE = 'absolute',
    MEDIA = 'media',
}

export enum RangeOrigin {
    DETECTION = 'detection',
    SELECTION = 'selection',
}
